module.exports = __webpack_public_path__ + "img/categoria.088efb5b.svg";